import React from 'react';

const InvalidTokenMessage = () => (
  <div>
    <p>Purtroppo, non puoi accedere direttamente a questo modulo. Ti preghiamo di provare ad accedervi tramite il link fornito via email.</p>
  </div>
);

export default InvalidTokenMessage;